module.exports = __webpack_public_path__ + "static/img/SamKerr.e2861cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SamKerr.jpg
// module id = ozbT
// module chunks = 0